<template>
  <div class="research_wrap">
    <template v-if="hiddenThreeNav1">
      <el-carousel height="37vw" loop arrow="never" class="hidden-xs-only" indicator-position="none">
        <el-carousel-item>
          <img :src="threeNav1.image" alt="" class="img_item" />
          <div class="tips_font">
            <h1 v-html="threeNav1.title"></h1>
          </div>
        </el-carousel-item>
      </el-carousel>

      <div class="production_img hidden-sm-and-up">
        <div class="img_tit" v-html="threeNav1.title"></div>
      </div>
    </template>

    <template v-if="hiddenThreeNav2">
      <div class="research_card hidden-xs-only">
        <div class="research-left">
          <div class="research-left-title">{{ threeNav2Title[0]?.title }}</div>
          <div class="research-left-desc">
            {{ threeNav2.subtitle }}
          </div>
          <div class="research-left-instrc">{{ threeNav2Title[1]?.title }}</div>
          <ul>
            <li class="research-left-detail" v-for="(item, index) in threeNav2Children" :key="index">
              <span>{{ item.Title }}：</span>
              {{ item.SubTitle }}
            </li>
          </ul>
        </div>
        <div class="research_card_right">
          <img :src="threeNav2.image" alt="" />
        </div>
      </div>

      <div class="research_card_mobile hidden-sm-and-up">
        <h1>{{ threeNav2Title[0]?.title }}</h1>
        <p>
          {{ threeNav2.subtitle }}
        </p>
        <h2>{{ threeNav2Title[1]?.title }}</h2>
        <ul style="margin-top: 12px;">
          <li v-for="(item, index) in threeNav2Children" :key="index" style="font-size: 14PX;color: #666;">
            <span>{{ item.Title }}：</span>
            {{ item.SubTitle }}
          </li>
        </ul>
        <img src="@/assets/img/build.543dd76.png" alt="" />
      </div>
    </template>

    <template v-if="hiddenThreeNav3">
      <div class="research_title_wrap">
        <div class="research_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="research_title">{{ threeNav3.title }}</div>
            <div class="research_desc"></div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>

      <div class="research_sp_wrap hidden-xs-only">
        <el-row type="flex" justify="space-between" class="research_sp_row" :gutter="10">
          <el-col :span="7" class="research_sp_col" v-for="(item, index) in threeNav3Children" :key="index"
            :style="`background: url(${item.image}) 0 0 no-repeat;`">
            <div class="tit">{{ item.title }}</div>
            <div class="desc">
              {{ item.subTitle }}
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="research_sp_wrap_mobile hidden-sm-and-up">
        <img src="@/assets/img/content1.png" alt="">
      </div>
    </template>

    <div class="product_shows_wrap" v-if="hiddenThreeNav4">
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center" style="width: 40%">
            <div class="production_title">{{ threeNav4.title }}</div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="card_fan_list">
        <el-row class="card_fan_wrap" type="flex" justify="space-between">
          <el-col class="card_fan_item" :span="11" v-for="(item, index) in threeNav4Children" :key="index">
            <div class="card_left hidden-xs-only">
              <img :src="item.image" alt="" />
            </div>
            <div class="card_right">
              <h1>{{ item.title }}</h1>
              <p>{{ item.subTitle }}</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <template v-if="hiddenThreeNav5">
      <div class="research_title_wrap">
        <div class="research_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center" style="width: 70%">
            <div class="research_title">{{ threeNav5?.title }}</div>
            <div class="research_desc"></div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>

      <div class="develop_wrap">
        <div class="develop_left">
          <h1>{{ threeNav5Children.title }}</h1>
          <p>
            {{ threeNav5Children.subtitle }}
          </p>
        </div>
        <div class="develop_right">
          <img :src="threeNav5.image" alt="" />
          <!-- <a class="tips hidden-xs-only" href="http://www.cbib.org.cn/#/kpi/trendLine" target="_blank">官网入口>></a> -->
        </div>
      </div>
    </template>
    <CallMe />
    <BoottomTab />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import BoottomTab from '@/components/consulting/BoottomTab.vue'
import { leftLikeDict } from '../../api/system';
import Constant from '../../utils/Constant';
import { findDictHidden, findMainProp, findMainPropArr, transDictDataNotTypeMore, transDictDataNotTypeMore2, transDictDataTotal } from '../../utils';
export default {
  data() {
    return {
      hiddenThreeNav1: true,
      hiddenThreeNav2: true,
      hiddenThreeNav3: true,
      hiddenThreeNav4: true,
      hiddenThreeNav5: true,
      cardList: [
        {
          tit: '面向政府重大战略研究',
          desc: '北京市十四五生物医药产业战略规划',
          img: require('../../assets/img/researchInstitute/icon1.png')
        },
        {
          tit: '面向新基建产业新基建研究',
          desc: '产业新基建战略白皮书',
          img: require('../../assets/img/researchInstitute/icon2.png')
        },
        {
          tit: '面向行业指数研究产品',
          desc: '中国生物医药产业发展指数CBIB',
          img: require('../../assets/img/researchInstitute/icon3.png')
        },
        {
          tit: '面向智库研究数字化产品',
          desc: '政策/资本研究数字化工具数鉴.生物医药(2019)',
          img: require('../../assets/img/researchInstitute/icon4.png')
        },
      ],
      threeNav1: {},
      threeNav2Title: [],
      threeNav2: {},
      threeNav2Children: [],
      threeNav3: {},
      threeNav3Children: [],
      threeNav4: {},
      threeNav4Children: [],
      threeNav5: {},
      threeNav5Children: {}
    }
  },
  methods: {
    async leftLikeDictFunc() {
      const res = await leftLikeDict(Constant.THREENAV1);
      if (res.data) {
        this.hiddenThreeNav1 = findDictHidden(Constant.THREENAV1, res.data.data)
        this.threeNav1 = findMainProp(res.data.data, Constant.THREENAV1)
      }
      const res2 = await leftLikeDict(Constant.THREENAV2);
      if (res2.data) {
        this.hiddenThreeNav2 = findDictHidden(Constant.THREENAV2, res2.data.data)
        this.threeNav2Title = findMainPropArr(res2.data.data, Constant.THREENAV2)
        this.threeNav2 = findMainProp(res2.data.data, Constant.THREENAV2)
        this.threeNav2Children = transDictDataTotal(res2.data.data.find(v => v.dictKey === `threenav2Title2`)?.children, `threenav2Content`)
      }
      const res3 = await leftLikeDict(Constant.THREENAV3);
      if (res3.data) {
        this.hiddenThreeNav3 = findDictHidden(Constant.THREENAV3, res3.data.data)
        this.threeNav3 = findMainProp(res3.data.data, Constant.THREENAV3)
        this.threeNav3Children = transDictDataNotTypeMore(res3.data.data.find(v => v.dictKey === `threenav3Title`)?.children, 'threenav3Content')
      }
      const res4 = await leftLikeDict(Constant.THREENAV4);
      if (res4.data) {
        this.hiddenThreeNav4 = findDictHidden(Constant.THREENAV4, res4.data.data)
        this.threeNav4 = findMainProp(res4.data.data, Constant.THREENAV4)
        this.threeNav4Children = transDictDataNotTypeMore(res4.data.data.find(v => v.dictKey === `threenav4Title`)?.children, 'threenav4Content')
      }
      const res5 = await leftLikeDict(Constant.THREENAV5);
      if (res5.data) {
        this.hiddenThreeNav5 = findDictHidden(Constant.THREENAV5, res5.data.data)
        this.threeNav5 = findMainProp(res5.data.data, Constant.THREENAV5)
        this.threeNav5Children = findMainProp(res5.data.data.find(v => v.dictKey === `threenav5Title`)?.children, 'threenav5Content')
      }
    }
  },
  mounted() {
    this.leftLikeDictFunc()
  },
  components: {
    CallMe,
    MobileCallme,
    BoottomTab
  },
}
</script>

<style lang="scss" scoped>
.research_wrap {
  position: relative;
  width: 100%;

  .production_img {
    width: 100%;
    height: 600px;
    padding: 0 1rem;

    @media screen and (max-width: 768px) {
      height: 50vw;
    }

    background: url('../../assets/img/banner22.png') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    .img_tit {
      font-size: 60px;
      font-weight: bold;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .img_desc {
      font-size: 32px;
      margin-top: 20px;

      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }

    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        color: #fff;
        background: orange;
      }

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #2d3937;
    font-size: 25px;

    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }

  .research_card {
    width: 72%;
    margin: 0 auto;
    position: relative;
    z-index: 5;
    margin-top: -200px;
    background: #ffffff;
    padding: 40px;
    display: flex;
    background: url('../../assets/img/bg.722080d.png');
    background-size: 100% 100%;

    .research-left {
      .research-left-title {
        font-size: 34px;
        font-weight: bold;
        color: #000;
      }

      .research-left-desc {
        color: #5b6e74;
        line-height: 2rem;
        font-size: 19px;
      }

      .research-left-instrc {
        font-size: 24px;
        margin-top: 20px;
      }

      ul {
        .research-left-detail {
          font-size: 18px;
          margin-top: 12px;

          span {
            font-weight: bold;
            color: #000;
          }
        }
      }
    }

    .research_card_right {
      margin-left: 50px;
    }
  }

  .research_card_mobile {
    width: 100%;
    padding: 1rem;
    background: url('../../assets/img/bg.722080d.png') 0 0 no-repeat;
    background-size: cover;
    position: relative;

    h1 {
      font-size: 1.3rem;
    }

    p {
      margin-top: 1rem;
      font-size: 0.9rem;
      color: #5b6e74;
      line-height: 1.5rem;
    }

    h2 {
      margin-top: 1rem;
      font-weight: normal;
      font-size: 1rem;
      color: #000;
    }

    img {
      position: absolute;
      right: 1rem;
      width: 30%;
      bottom: -4rem;
      opacity: 0.6;
    }
  }

  .research_title_wrap {
    width: 100%;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .research_inner {
      display: flex;
      justify-content: center;

      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }

      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;

        @media screen and (max-width: 768px) {
          flex: 2.2;
        }

        .research_title {
          font-size: 40px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .research_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;

          @media screen and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }

      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 768px) {
          flex: 1;
        }

        img {
          width: 30%;
        }
      }
    }
  }

  .research_sp_wrap {
    width: 70%;
    margin: 0 auto;
    height: 300px;

    .research_sp_row {
      width: 100%;

      .research_sp_col {
        background-size: 100% 100%;
        height: 420px;
        padding: 200px;

        .tit {
          font-size: 32px;
          color: #000;
          margin: 0 30px;
        }

        .desc {
          font-size: 19px;
          margin: 10px 30px;
        }
      }
    }
  }

  .research_sp_wrap_mobile {
    width: 90%;
    margin: 0 auto;

    img {
      width: 100%;
    }
  }

  .product_shows_wrap {
    width: 100%;
    background: #f4f9fc;
    background-size: cover;
    padding: 10px 0 50px 0;
    box-sizing: border-box;
    margin-top: 250px;
    margin-bottom: 50px;

    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }

    .production_title_wrap {
      width: 100%;
      margin-top: 50px;

      @media screen and (max-width: 768px) {
        margin-top: 30px;
      }

      .production_inner {
        display: flex;
        justify-content: center;

        .inner_left {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          @media screen and (max-width: 768px) {
            flex: 1;
          }

          img {
            width: 30%;
          }
        }

        .inner_center {
          width: 400px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0 50px;

          @media screen and (max-width: 768px) {
            flex: 2.2;
          }

          .production_title {
            font-size: 40px;
            font-weight: bold;

            @media screen and (max-width: 768px) {
              font-size: 1rem;
            }
          }

          .production_desc {
            font-size: 16px;
            color: #787878;
            margin-top: 10px;

            @media screen and (max-width: 768px) {
              margin-top: 10px;
            }
          }
        }

        .inner_right {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          @media screen and (max-width: 768px) {
            flex: 1;
          }

          img {
            width: 30%;
          }
        }
      }
    }

    .card_fan_list {
      width: 70%;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .card_fan_wrap {
        flex-wrap: wrap;
        margin-top: 50px;
      }

      .card_fan_item {
        display: flex;
        align-items: center;
        background: #fff;
        margin-top: 50px;
        padding: 30px;
        box-shadow: 10px 10px 20px rgba($color: #000, $alpha: 0.1);

        @media screen and (max-width: 768px) {
          background: url('../../assets/img/icon2.png') 0 0 no-repeat;
          background-position: 100% 100%;
          background-size: 35%;
          height: 100px;

          &:nth-child(n+3) {
            margin-top: 25px;
          }
        }

        .card_left {
          width: 20%;

          img {
            width: 100%;
          }
        }

        .card_right {
          margin-left: 15px;

          h1 {
            font-size: 25px;

            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }

          p {
            font-size: 18px;
            margin-top: 10px;

            @media screen and (max-width: 768px) {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .develop_wrap {
    width: 70%;
    margin: 0 auto;
    display: flex;

    @media screen and (max-width: 768px) {
      width: 90%;
      flex-direction: column;
      margin-bottom: 30px;
    }

    .develop_left {
      margin-right: 100px;

      h1 {
        font-size: 26px;

        @media screen and (max-width: 768px) {
          font-size: 0.95rem;
        }
      }

      p {
        margin-top: 30px;
        font-size: 20px;
        color: #5b6e74;

        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }
    }

    .develop_right {
      width: 100%;

      @media screen and (max-width: 768px) {
        width: 40%;
        margin: 0 auto;
      }

      img {
        width: 100%;
      }

      .tips {
        text-align: center;
        color: #2091d3;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>